<template lang="html">

<div class="slds-form-element">
  
  <div class="slds-form-element__control">
    <div class="slds-combobox_container">

      <div v-bind:class="{'slds-is-open':show}" class="slds-combobox slds-dropdown-trigger slds-dropdown-trigger_click" aria-expanded="true" aria-haspopup="listbox" role="combobox">

        <div class="slds-combobox__form-element slds-input-has-icon slds-input-has-icon_right" role="none">
          <input v-on:focus="focus(true)" v-on:blur="preblur(false)" v-on:keydown="change" type="text" 
            v-bind:class="{'slds-has-focus':show}" v-model="value"
            class="slds-input slds-combobox__input slds-combobox__input-value"
            aria-activedescendant="option1" aria-autocomplete="list" aria-controls="listbox-id-4"
            autoComplete="off" role="textbox" v-bind:placeholder="$t('Autocomplete')" />
          <span class="slds-icon_container slds-icon-utility-search slds-input__icon slds-input__icon_right">
            <svg class="slds-icon slds-icon slds-icon_x-small slds-icon-text-default" aria-hidden="true">
              <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#search"></use>
            </svg>
          </span>
        </div>

        <div v-if="show" id="listbox-id-4" class="slds-dropdown slds-dropdown_length-with-icon-7 slds-dropdown_fluid" role="listbox">
          <ul class="slds-listbox slds-listbox_vertical" role="presentation">

            <li role="presentation" class="slds-listbox__item" >
              <div aria-selected="true" id="option0"
                class="slds-media slds-listbox__option slds-listbox__option_entity slds-listbox__option_term slds-has-focus"
                role="option">
                <span class="slds-media__figure slds-listbox__option-icon">
                  <span class="slds-icon_container slds-icon-utility-search" title="Search for term: ">
                    <svg class="slds-icon slds-icon_x-small slds-icon-text-default" aria-hidden="true">
                      <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#search"></use>
                    </svg>
                    <span class="slds-assistive-text">Search for term: </span>
                  </span>
                </span>
                <span class="slds-media__body">
                  <span class="slds-listbox__option-text slds-listbox__option-text_entity">{{value}}</span>
                </span>
              </div>
            </li>

            <li v-on:click="click(index)" role="presentation" class="slds-listbox__item" v-for="(f,index) in founded" v-bind:key="f.id">
              <div id="option1"
                class="slds-media slds-listbox__option slds-listbox__option_entity slds-listbox__option_has-meta"
                role="option">
                <span class="slds-media__figure slds-listbox__option-icon">
                  <span class="slds-icon_container slds-icon-standard-account">
                    <svg class="slds-icon slds-icon_small" aria-hidden="true">
                      <use v-bind:xlink:href="'/assets/icons/standard-sprite/svg/symbols.svg#'+object"></use>
                    </svg>
                  </span>
                </span>
                <span class="slds-media__body">
                  <span class="slds-listbox__option-text slds-listbox__option-text_entity">
                    <span>
                      <mark>{{f.name}}</mark>
                    </span>
                  </span>
                  <span v-if="false" class="slds-listbox__option-meta slds-listbox__option-meta_entity">{{object}} • {{f.value}}</span>
                </span>
              </div>
            </li>

          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

</template>

<script>

export default {
  name: 'gmapaddress',
  components: {
  },
  computed: {
  },
  props: {
    label: String, // etichetta campo
    selected: String, // valore selezionato
    placeholder: String // valore selezionato
    // on change = deve lanciare la ricerca del valore
    // on click = valore selezionato (indice)
  },
  data() {
    return {
      object:'address',
      value:'',
      timer:'',
      timerBlur:'',
      show: false,
      founded: [],
      places: [],
      service:{},
      serviceplaces:{},
    }
  },
  mounted: function() {
    // eslint-disable-next-line no-undef
    this.service = new google.maps.places.AutocompleteService();
    // eslint-disable-next-line no-undef
    this.serviceplaces = new google.maps.places.PlacesService(this.$store.getters.map);
  },
  async created() {

  },
  methods: {
    autocomplete: function() {
      var self=this;
      this.service.getPlacePredictions( { input: this.value,  types: ['address'] } , function(res, status) { 
        console.log('prediction!')
        // eslint-disable-next-line no-undef
        if (status != google.maps.places.PlacesServiceStatus.OK) {
          // alert(status);
          return;
        }        

        console.log(res);
        self.founded=[];
        self.places=[];
        res.forEach(function(r) {
          self.founded.push( { id: r.place_id, name: r.description , value: r.description } );
          self.places.push(r);
        });

      })
    },
    preblur: function() { // chiude la picklist, ma a tempo per evitare altri eventi
      console.log('preblur');
      if (this.timerBlur) clearTimeout(this.timerBlur);
      var self=this;
      this.timerBlur=setTimeout(function() {
        console.log('blurring');
        self.show=false;
      }, 200);
    },
    focus: function(status) {
      this.show=status;
    },
    change: function() {
      console.log('clack');

      if (this.timer) clearTimeout(this.timer);
      var self=this;
      this.timer=setTimeout(function() {
        console.log('search');
        if (!self.value) return;
        self.show=true;
        self.autocomplete();
        // self.$emit('change', self.value);
      }, 500);

    },
    click: function(index) {
      console.log('click');
      console.log(index);
      this.value=this.founded[index].name;

      var self=this;
      self.serviceplaces.getDetails( {placeId: this.places[index].place_id},  function(res, status) { 
        console.log('place!')
        // eslint-disable-next-line no-undef
        if (status != google.maps.places.PlacesServiceStatus.OK) {
          alert(status);
          return;
        }        
        console.log(res);
        var address={};
        res.address_components.forEach(function(c) {
          switch (c.types[0]) {
            case 'street_number':
              address['ShippingStreet']=c.long_name;
              break;
            case 'route':
              if (address['ShippingStreet'])
                address['ShippingStreet']=c.long_name+', '+address['ShippingStreet'];
              else
                address['ShippingStreet']=c.long_name;
              break;
            case 'locality':
              address['ShippingCity']=c.long_name;
              break;
            case 'administrative_area_level_3':
            case 'administrative_area_level_2':
            case 'administrative_area_level_1':
              if (!address['ShippingState']) // il primo che arriva
                address['ShippingState']=c.long_name;
              break;
            case 'country':
                address['ShippingCountry']=c.long_name;
              break;
            case 'postal_code':
                address['ShippingPostalCode']=c.long_name;
              break;
          }
        });
        if (res.geometry) {
          if (res.geometry.location) {
            address['FN__Lat__c']=res.geometry.location.lat();
            address['FN__Lon__c']=res.geometry.location.lng();
            // address['ShippingLatitude']=res.geometry.location.lat();
            // address['ShippingLongitude']=res.geometry.location.lng();
          }
        }
        self.$emit('change', address );
      })


    },
  }
}
</script>

<style scoped>
</style>
